import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_delete-circle",
  "use": "svg_delete-circle-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"svg_delete-circle\"><rect x=\"1\" y=\"1\" width=\"30\" height=\"30\" rx=\"15\" fill=\"#FD787A\" /><path d=\"m20 12-8 8M12 12l8 8\" stroke=\"#fff\" stroke-width=\"1.344\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><rect x=\"1\" y=\"1\" width=\"30\" height=\"30\" rx=\"15\" stroke=\"#fff\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol